import React from 'react';
import './Services.css';

const Services = () => {
  const serviceItems = [
    {
      image: "/img/EngineeringConsultation.png",
      title: "Engineering Consultation",
      link: "services/Engineering-Consultation",
      description: "Mikan provides expert engineering consultation, offering solutions to optimize processes, improve efficiency, and ensure compliance with industry standards. Our team supports clients through every project phase, from feasibility studies to design, development, and implementation."
    },
    {
      image: "/img/BIMService.png",
      title: "BIM Service",
      link: "services/bim",
      description: "Our Building Information Modeling (BIM) services offer cutting-edge 3D modeling to streamline construction processes, enhance collaboration, and reduce errors. We help clients visualize and manage their building projects with precision and clarity."
    },
    {
      image: "/img/StructuralEngineering.png",
      title: "Structural Engineering",
      link: "services/Structual-Engineerine",
      description: "Mikan delivers comprehensive structural engineering solutions, ensuring safe, efficient, and sustainable designs. Our expertise ranges from analyzing complex structures to providing innovative solutions that meet client-specific requirements in various industries."
    },
    {
      image: "/img/FabricationandSupply.png",
      title: "Manufacturing and Supply",
      link: "services/Manufacturing-Supple",
      description: "We provide end-to-end manufacturing and supply services, from product design and prototyping to full-scale production and delivery. Mikan focuses on high-quality, cost-effective solutions tailored to your business needs"
    },
    {
      image: "/img/OffshoreServise.png",
      title: "OffShore Services",
      link: "services/OffShore",
      description: "Our offshore services include engineering, project management, and maintenance for oil, gas, and marine industries. We specialize in delivering safe and efficient offshore operations, ensuring high standards of reliability and performance."
    },
    {
      image: "/img/renewableenergy.png",
      title: "Process Plant",
      link: "services/Process-Plant",
      description: "Mikan is committed to advancing renewable energy solutions, offering design and implementation services for solar, wind, and other sustainable energy projects. We help clients transition to greener energy sources with innovative and efficient systems."
    }
  ];

  return (
    <div className="service">
      <div className="container">
        <div className="section-header text-center">
          <h2>Our Services</h2>
        </div>
        <div className="row">
          {serviceItems.map((service, index) => (
            <div 
              key={index}
              className="col-lg-4 col-md-6 wow fadeInUp" 
              data-wow-delay={`0.${index + 1}s`}
            >
              <div className="service-item">
                <div className="service-img">
                  <img src={service.image} alt={service.title} />
                  <div className="service-overlay">
                    <p>{service.description}</p>
                  </div>
                </div>
                <div className="service-text">
                  <h3>{service.title}</h3>
                  <a className="btn" href={service.link}>+</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;